import React from 'react'

type YoutubePlayerProps = {
  youtubeId: string
}

export const YoutubePlayer = ({ youtubeId }: YoutubePlayerProps) => {
  return (
    <div className="ratio ratio-16x9">
      <iframe
        src={`https://www.youtube.com/embed/${youtubeId}`}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      ></iframe>
    </div>
  )
}
